import type { ReactNode } from 'react';

// PR-UX-02 token · 11px tracked uppercase, mono. Colors map semantic role.
type Tone = 'vermilion' | 'azure' | 'gold' | 'jade' | 'ink' | 'ash';

interface EyebrowProps {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

const TONE_CLASS: Record<Tone, string> = {
  vermilion: 'text-vermilion',
  azure: 'text-azure-700',
  gold: 'text-gold-700',
  jade: 'text-jade-700',
  ink: 'text-ink-2',
  ash: 'text-ink-3',
};

export default function Eyebrow({ tone = 'vermilion', children, className = '' }: EyebrowProps) {
  return (
    <span
      className={`font-mono text-[11px] tracking-meta uppercase ${TONE_CLASS[tone]} inline-block ${className}`}
    >
      {children}
    </span>
  );
}
